import React, {Component} from 'react'

import Popup from '../Popup/index'

import Registry from '../../../registry/index';

import {availableStyles} from '../../../constants/chatEditorOwn';
import {uniqueId} from '../../../utils'

class ChatEditorTextColorPopup extends Popup {
    constructor(props) {
        super(props);

        this.colors = availableStyles.color;
    }

    componentDidMount() {
        super.componentDidMount();

        this.setState({
            ...super.state,
            savedColor: ''
        });
    }

    position() {
        if (!this.$anchor || this.$anchor.length === 0) return;

        var offset = this.$anchor.offset(),
            width = this.$popup.width(),
            height = this.$popup.height();

        this.$popup.css({
            left: (offset.left - width) + "px",
            top: (offset.top - height - 16) + "px"
        });
    }

    setColor(value) {
        let {dispatch} = this.props;
        dispatch({type: 'EDITOR_TEXT_COLOR', value: value});
        this.close();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            savedColor: nextProps.editorStyle.textColor
        })
    }

    render() {
        let lang = Registry.get('locale');

        var colors = this.colors;

        let className = 'popup block-text-color ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                {colors.map((color) => <a key={color} className={color == this.state.savedColor ? "color active" : "color"} onClick={() => this.setColor(color)} style={{backgroundColor: color}}></a>)}
            </div>
        )
    }

}

ChatEditorTextColorPopup.generateKey = function(props) {
    return 'room-editor-text-color-popup-' + uniqueId();
};

ChatEditorTextColorPopup.mount = function(props) { return Popup.mount(ChatEditorTextColorPopup, props) };

export default ChatEditorTextColorPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorTextColorPopup/index.js